export const costs = [
  'You build every climate lesson from scratch, hunting for diagrams and data you can actually trust',
  'Students mix up weather and climate, the greenhouse effect and the ozone hole, and bring confusing headlines to class',
  "You don't have clear visuals, classroom examples and activities ready to use",
  'You lack the time to plan a complete, balanced climate unit — from the atmosphere to the evidence, impacts and solutions',
];
